import React from 'react'
import { Line } from 'react-chartjs-2'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from 'chart.js'
import { formatPeriodo, formatBs } from './utils'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler)

export const TwoLineTrendChart = ({ serieA, serieB, labelA, labelB, colorA = '#06d6a0', colorB = '#ef476f', title }) => {
    const granularidad = serieA?.granularidad || serieB?.granularidad || 'day'

    const periodosSet = new Set([
        ...(serieA?.serie ?? []).map((p) => p.periodo),
        ...(serieB?.serie ?? []).map((p) => p.periodo),
    ])
    const periodos = Array.from(periodosSet).sort()
    const labels = periodos.map((p) => formatPeriodo(p, granularidad))

    const byPeriodoA = new Map((serieA?.serie ?? []).map((p) => [p.periodo, p.total]))
    const byPeriodoB = new Map((serieB?.serie ?? []).map((p) => [p.periodo, p.total]))

    const dataA = periodos.map((p) => byPeriodoA.get(p) || 0)
    const dataB = periodos.map((p) => byPeriodoB.get(p) || 0)
    const hayDatos = dataA.some((v) => v > 0) || dataB.some((v) => v > 0)

    const misoptions = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: 'nearest', intersect: true },
        plugins: {
            legend: {
                position: 'bottom',
                labels: { color: 'rgba(170,170,170)', boxWidth: 12, font: { size: 10 } },
            },
            tooltip: {
                mode: 'nearest',
                intersect: true,
                callbacks: { label: (ctx) => `${ctx.dataset.label}: Bs ${formatBs(ctx.raw)}` },
            },
        },
        scales: {
            y: {
                min: 0,
                ticks: { color: 'rgba(170,170,170)' },
                grid: { color: 'rgba(170,170,170,.2)' },
            },
            x: {
                ticks: { color: 'rgba(170,170,170)', autoSkip: true, maxRotation: 45 },
                grid: { display: false },
            },
        },
    }

    return (
        <div className='w-full min-w-0'>
            <div className='text-base dark:text-gray-300 text-gray-800 font-bold text-center mb-2'>{title}</div>
            {!hayDatos ? (
                <div className='text-sm text-gray-500 dark:text-gray-400 italic text-center py-8'>
                    Sin datos para el rango seleccionado
                </div>
            ) : (
                <div className='w-full min-w-0 h-64 sm:h-80'>
                    <Line
                        data={{
                            labels,
                            datasets: [
                                {
                                    label: labelA,
                                    data: dataA,
                                    borderColor: colorA,
                                    backgroundColor: colorA,
                                    tension: 0.3,
                                    pointRadius: 3,
                                    pointHoverRadius: 6,
                                    pointHitRadius: 10,
                                    borderWidth: 2,
                                },
                                {
                                    label: labelB,
                                    data: dataB,
                                    borderColor: colorB,
                                    backgroundColor: colorB,
                                    tension: 0.3,
                                    pointRadius: 3,
                                    pointHoverRadius: 6,
                                    pointHitRadius: 10,
                                    borderWidth: 2,
                                },
                            ],
                        }}
                        options={misoptions}
                    />
                </div>
            )}
        </div>
    )
}
